module.exports = __webpack_public_path__ + "img/app.67c06296.png";